import request from '@/utils/req.js';
// 标准数据库食材库树结构
export function apiGetFoodTrees(params) {
    return request.get(`/admin/standard-category/getDelicaciesTree`,params);
}
// 分页查询
export function apiPostFoodPage(params) {
    return request.post(`/admin/delicacies/page`,params);
}
//搜索食物接口
export function apiPostFoodList(params) {
    return request.post(`/admin/food/list`,params);
}
// 菜肴添加
export function apiPostAddFood(params) {
    return request.post(`/admin/delicacies`,params);
}
//菜肴库删除
export function apiDeleteFood(params) {
    return request.delete(`/admin/delicacies/${params}`);
}
//菜肴库详细查询
export function apiGetFood(params) {
    return request.get(`/admin/delicacies/${params}`);
}
//食材库启用-停用
export function apiUpdateStatusFood(params) {
    return request.put(`/admin/delicacies/updateStatus/${params}`);
}